/*
 * @Author: huangzq
 * @Date: 2020-04-07 22:39:08
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 14:54:40
 * @Desc: 添加企业文件夹公用弹窗-mk-drawer-biz-two已改，没问题了
*/
<template>
  <div class="materials-dialog">
    <mk-drawer-biz-two
      :visible="visible"
      :title="title"
      :append-to-body="true"
      :modal-append-to-body="true"
      :select-num="section.length"
      with-select
      size="820px"
      confirm-text="添 加"
      @open="handelOnDrawerOpen"
      @close="handelOnDrawerClose"
      @cancel="handelOnDrawerClose"
      @confirm="handelOnDrawerConfirm"
    >
      <list-biz
        v-if="visible"
        v-loading="listBizLoading"
        :config="config"
        :data="listData"
        :total="total"
        :page="params.page"
        :infinite-scroll-disabled="infiniteScrollDisabled"
        :choose-list="chooseList"
        :id-key="idKey"
        hide-selection
        @on-type-change="handleOnTypeChange"
        @on-search-change="handelOnSearchClick"
        @on-reset-change="handelOnResetClick"
        @on-current-change="handleOnCurrentChange"
        @on-select-change="handleOnSelectChange"
        @on-load-change="handleOnLoadChange"
      />
    </mk-drawer-biz-two>
  </div>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import componentMap from '../config/componentMap'

export default {
  name: 'MaterialsDialog',
  components: { MkDrawerBizTwo },
  props: {
    // 是否显示资料选择弹窗
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '导入课件'
    },
    chooseList: {
      type: Array,
      default: () => []
    },
    // 课件最多可添加数量-目前为100
    maxNum: {
      type: Number,
      default: 100
    },
    // 课件一次最多可添加数量-目前为20
    oneMaxNum: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      type: 'picture',
      // 当前被选中的资料id
      section: [],
      // 当前类型对应list-biz的config数据
      config: {},
      // 对应资料的列表数据
      listData: [],
      // 对应资料的数据总数
      total: 0,
      // 接口参数数据
      params: {
        page: 1,
        pageSize: 10,
        name: '',
        // 类型：图片:1，视频:2，文件:3
        type: 3,
        // 文件类型,只有当type=3的时候才有
        fileType: 0
      },
      // 所有组件数据
      componentMap,
      // 是否禁用滚动加载事件
      infiniteScrollDisabled: false,
      // list-biz的loading效果
      listBizLoading: false,
      idKey: '_id'
    }
  },
  methods: {
    // 弹窗打开事件
    handelOnDrawerOpen () {
      this.type = 'file'
      this.config = this._.cloneDeep(this.componentMap[this.type])

      this.handelOnResetClick()
    },

    // 类型切换事件
    handleOnTypeChange (type) {
      if (this.type !== type) {
        this.type = type
        this.config = this._.cloneDeep(this.componentMap[type])

        this.handelOnResetClick()
      }
    },

    // 搜索按钮点击事件
    handelOnSearchClick (params = {}) {
      delete params.type
      this.listData = []
      this.section = []

      this.params = {
        ...this.params,
        ...params,
        page: 1
      }

      // 参数处理
      if (this.type === 'file') {
        this.params.fileType = params.select || 0
      }

      // if (type === 'picture' || type === 'ordinaryVideo') {
      this.params.name = params.title
      // }

      // 这里还要区分下类型
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, this.config.mode === 'image')
    },

    // 重置按钮事件
    handelOnResetClick (params = {}) {
      this.listData = []
      this.section = []

      this.params = {
        page: 1,
        pageSize: 10,
        name: '',
        // 类型：图片:1，视频:2，文件:3
        type: 3,
        // 文件类型,只有当type=3的时候才有
        fileType: 0,
        ...params
      }

      // 图片接口参数
      if (this.config.params.type === 'picture') {
        this.params.type = 1
      } else if (this.config.params.type === 'ordinaryVideo') {
        this.params.type = 2
      } else if (this.config.params.type === 'file') {
        this.params.type = 3
      }

      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, this.config.mode === 'image')
    },

    // 翻页事件
    handleOnCurrentChange (value) {
      this.params.page = value
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, false)
    },

    // 滚动加载事件
    handleOnLoadChange () {
      this.params.page++
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, true)
    },
    // 根据类型获取对应的接口api
    ajaxMap (type) {
      const map = {
        'picture': MKMATERIALSVC.MbamaterialApi.mbamaterialListPost,
        'ordinaryVideo': MKMATERIALSVC.MbamaterialApi.mbamaterialListPost,
        'file': MKMATERIALSVC.MbamaterialApi.mbamaterialListPost
      }
      return map[type]
    },

    // 获取页面数据
    async getListBizData (func, params, load = false) {
      this.listBizLoading = true
      // 这里进行数据处理，返回数据
      const { success, data: { data, list, total, count }, msg } = await func(params)

      if (success) {
        // 对 返回数据进行处理
        let currentList = this.transformMap(data || list)
        // 禁用部分格式方法
        if (this.type === 'file') {
          currentList = this.disableFormatByKey(currentList, ['wma', 'wav'])
        }
        if (load) {
          // 无限加载事件
          this.listData = this.listData.concat(currentList)
          this.infiniteScrollDisabled = currentList.length < this.params.pageSize
        } else {
          // 翻页事件
          this.listData = currentList
          this.total = total || count
        }
      } else {
        this.$message.error(msg)
      }
      this.$nextTick(() => {
        this.listBizLoading = false
      })
    },

    // 处理普通素材的数据：因为普通素材没有cover、title、releaseTime等，所以需要将其他的转为符合的字段
    transformMap (listData) {
      let list = []
      listData.forEach(item => {
        if (item.url) {
          item.cover = item.url
        }
        if (item.name) {
          item.title = item.name
        }
        // 后端返回的文件的种类的字段名category改为type，与下面定义的type重复了，这里重新赋值
        item.category = item.type
        item.type = this.config.name || 'ordinaryVideo'
        // 商品封面图处理
        if (item.carouselPicture) {
          if (item.carouselPicture.length > 0) {
            item.cover = item.carouselPicture[0].url || ''
          }
          // 这里字段有重复，先这样处理
          item.type = 'good'
        }
        list.push(item)
      })
      return list
    },

    // 禁用部分格式方法
    disableFormatByKey (list = [], disableFormat = []) {
      let newList = list.map(item => {
        if (disableFormat.includes(item.suffix)) {
          item.disableFormat = true
        }
        return item
      })
      return newList
    },

    // 表格选中事件
    handleOnSelectChange (section) {
      this.section = section
    },

    // 弹窗关闭事件
    handelOnDrawerClose () {
      this.$emit('update:visible', false)
    },

    // 弹窗确认事件
    handelOnDrawerConfirm () {
      const length = this.section.length
      if (length) {
        if (length > this.oneMaxNum) {
          this.$message.error(`一次性添加数量最多${this.oneMaxNum}个`)
        } else {
          if (length + this.chooseList.length > this.maxNum) {
            let msg = `课件内容最多可添加${this.maxNum}项`
            if (this.chooseList.length) {
              msg += `，目前已添加了${this.chooseList.length}项`
            }
            this.$message.error(msg)
          } else this.$emit('on-confirm', this.section)
        }
      } else {
        this.$message.error('请先选择资料')
      }
    }

  }
}
</script>
